import React, { useCallback } from "react";
import { SitebarCollapsable } from "components/SitebarCollapsable";
import { BasicFilters } from "./BasicFilters";
import { FilterToggle } from "./FilterToggle";
import { AdvancedFilters } from "./AdvancedFilters";
import { FA } from "components/FA";
import { useSearch } from "hooks";

const SearchFilter = () => {
  const { query, actions } = useSearch();
  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      actions.execute();
    },
    [actions]
  );
  return (
    <SitebarCollapsable header="Filters" toggled>
      <form onSubmit={handleSubmit}>
        <FilterToggle />
        {!query.isAdvanced ? <BasicFilters /> : <AdvancedFilters />}
        <button className="btn btn-sm btn-primary" type="submit">
          <FA icon="search" size="xs" /> <span className="label">Search</span>
        </button>
      </form>
    </SitebarCollapsable>
  );
};

export { SearchFilter };
